<template>
  <v-app dark>
    <!-- <SideNavigation v-model="drawer"/> -->
    <Toolbar/>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
// import SideNavigation from '@/components/Core/SideNavigation'
import Toolbar from '@/components/Core/Toolbar'
import Footer from '@/components/Core/Footer'

export default {
  components: {
    // SideNavigation,
    Toolbar,
    Footer
  },

  data: () => ({
    drawer: null
  })
}
</script>
